import { CustomQuestionConfig, selectQuestionnaireAsQuestionnaireConfigFactory } from "@teamprevent/common/questionnaires/questionnaireConfig";

import { MedicalTypeId } from "@teamprevent/common/healthSurveillance";
import { CustomMedicalType, HealthSurveillanceSectionConfig } from "@teamprevent/common/healthSurveillance/models";
import { values } from "lodash";

import {
    HavsClinicalAssessmentOfHistoryAndExaminationKey
} from "./components/HavsClinicalAssessmentOfHistoryAndExaminationQuestions";

import { sections as consultationSections } from "./consultation";
import { HealthSurveillanceConsultationKey, HealthSurveillanceRepeatMedicalConsultationKey } from "./components/HealthSurveillanceConsultation";

export const selectHealthSurveillanceConsultationAsQuestionnaireConfig = selectQuestionnaireAsQuestionnaireConfigFactory(HealthSurveillanceConsultationKey);

export const selectHealthSurveillanceRepeatMedicalConsultationAsQuestionnaireConfig =
    selectQuestionnaireAsQuestionnaireConfigFactory(HealthSurveillanceRepeatMedicalConsultationKey);

export const selectHavsClinicalAssessmentOfHistoryAndExaminationAsQuestionnaireConfig =
    selectQuestionnaireAsQuestionnaireConfigFactory(HavsClinicalAssessmentOfHistoryAndExaminationKey);

export const questionConfigsForConsultationSelector = (
    medicalTypes: MedicalTypeId[],
    customMedicalTypeConfigs: CustomMedicalType[]
) => {
    const sectionsWithMedicals = values<HealthSurveillanceSectionConfig>(consultationSections)
        .map(section => ({
            ...section,
            medicalTypes: [
                ...section.medicalTypes,
                ...customMedicalTypeConfigs
                    .filter(c => medicalTypes.indexOf(c.id) !== -1)
                    .filter(c => c.consultationSectionIds.indexOf(section.id) !== -1).map(c => c.id)
            ]
        }));
    const sectionsApplicableToGivenMedicals = sectionsWithMedicals
        .filter(section =>
            section.medicalTypes.some(t => medicalTypes.indexOf(t) !== -1) ||
            section.questionConfigs.some(q => "medicalTypes" in q && q.medicalTypes?.some(t => medicalTypes.indexOf(t) !== -1))
        );
    return sectionsApplicableToGivenMedicals
        .reduce<CustomQuestionConfig[]>((prevValue, currentValue) => [
            ...prevValue,
            ...currentValue.questionConfigs.filter(q =>
                currentValue.medicalTypes.some(t => medicalTypes.indexOf(t) !== -1) ||
                q.medicalTypes?.some(t => medicalTypes.indexOf(t) !== -1))
        ], []);
};
